import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError("");

    if (!id || !token) {
      setError("This reset link is missing required information.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords don't match.");
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(
        `${API_BASE_URL}/auth/reset-password`,
        { id, token, password }
      );
      alert("Password has been reset. Please log in with your new password.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(
        err.response?.data || "Something went wrong. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (!id || !token) {
    return (
      <div className="flex justify-center items-center h-screen bg-paper">
        <div className="bg-card border border-line p-8 rounded-lg w-96">
          <h2 className="text-xl font-semibold mb-4 text-ink">Reset password</h2>
          <p className="text-primary text-sm mb-4">
            This reset link is missing required information. Request a new
            one from the login page.
          </p>
          <Link
            to="/forgot-password"
            className="block text-center text-sm text-primary hover:underline"
          >
            Request a new link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen bg-paper">
      <div className="bg-card border border-line p-8 rounded-lg w-96">
        <h2 className="text-xl font-semibold mb-4 text-ink">Reset password</h2>
        <form onSubmit={handleSubmit}>
          {error && <p className="text-primary text-sm mb-3">{error}</p>}
          <input
            type="password"
            name="password"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border border-line p-2 w-full mb-4 rounded focus:ring focus:ring-primary/30"
            required
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="border border-line p-2 w-full mb-4 rounded focus:ring focus:ring-primary/30"
            required
          />
          <p className="text-muted text-xs mb-4">
            At least 8 characters, mixing uppercase, lowercase, numbers, and
            symbols.
          </p>
          <button
            type="submit"
            disabled={submitting}
            className="bg-primary text-white p-2 w-full rounded hover:opacity-90 transition disabled:opacity-50"
          >
            {submitting ? "Resetting..." : "Reset password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
